import React from 'react'

import Creditcards from "../Utils/Creditcards/Creditcards";
import { useTranslation } from "react-i18next";

const acceptedCards = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <ul className="payment-icons" aria-label={t('payment.accepted')} title={t('payment.accepted')}>
            <li className="payment-icon" aria-label={t('payment.card_type.VISA')} title={t('payment.card_type.VISA')}>
                <Creditcards type="VISA" />
                <span className="visually-hidden">{t('payment.card_type.VISA')}</span>
            </li>
            <li className="payment-icon" aria-label={t('payment.card_type.MC')} title={t('payment.card_type.MC')}>
                <Creditcards type="MC" />
                <span className="visually-hidden">{t('payment.card_type.MC')}</span>
            </li>
        </ul>
    )
}

export default acceptedCards
